import { useMemo } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import useViewDepartment from 'src/hooks/useViewDepartments';
import DepartmentMemberCell from 'src/sections/view_department/tableToolbar/DepartmentMemberCell';

export const useMemberColumn = () => {
  const { t } = useViewDepartment();
  const memberColumns: GridColumn<any>[] = useMemo(
    () => [
      {
        field: 'selected',
        title: '',
        className: 'text-center',
        filter: 'boolean',
        menu: false,
        dataType: 'fixed',
        sortable: false,
      },
      {
        field: 'name',
        title: t('Department Member'),
        component: DepartmentMemberCell,
        filter: 'text',
      },
    ],
    [t]
  );
  return memberColumns;
};
